import type { Definition, DocumentRow, PurchaseMovePayload, PurchaseRow } from "./api";

export const LANES = ["Planned", "PO sent", "Confirmed", "Received"] as const;

export function movePayload(purchase: PurchaseRow, today: string): PurchaseMovePayload | null {
  switch (purchase.lane) {
    case "Planned": return { purchase_id: purchase.purchase_id, po_date: today };
    case "PO sent": return { purchase_id: purchase.purchase_id, confirmed_date: today };
    case "Confirmed": return { purchase_id: purchase.purchase_id, received_date: today };
    default: return null;
  }
}

export function receivedState(purchase: PurchaseRow, receivedQty: string | null): "not_started" | "partly" | "complete" {
  if (receivedQty === null || Number(receivedQty) === 0) return "not_started";
  return Number(receivedQty) < Number(purchase.qty) ? "partly" : "complete";
}

/** Required documents of the purchase's material that are not attached to the purchase. */
export function missingDocuments(definition: Definition | undefined, docs: DocumentRow[]): string[] {
  const required = definition?.required_documents ?? [];
  const have = new Set(docs.map((document) => document.type));
  return required.filter((type) => !have.has(type));
}
